webpackJsonp([59361653251145],{

/***/ 59:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _classCallCheck2 = __webpack_require__(23);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(30);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(29);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _objectWithoutProperties2 = __webpack_require__(69);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _extends2 = __webpack_require__(68);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(5);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Handle legacy names for image queries.
	var convertProps = function convertProps(props) {
	  var convertedProps = (0, _extends3.default)({}, props);
	  if (convertedProps.responsiveResolution) {
	    convertedProps.resolutions = convertedProps.responsiveResolution;
	    delete convertedProps.responsiveResolution;
	  }
	  if (convertedProps.responsiveSizes) {
	    convertedProps.sizes = convertedProps.responsiveSizes;
	    delete convertedProps.responsiveSizes;
	  }
	
	  return convertedProps;
	};
	
	// Cache if we've seen an image before so we don't both with
	// lazy-loading & fading in on subsequent mounts.
	var imageCache = {};
	var inImageCache = function inImageCache(props) {
	  var convertedProps = convertProps(props);
	  // Find src
	  var src = convertedProps.sizes ? convertedProps.sizes.src : convertedProps.resolutions.src;
	
	  if (imageCache[src]) {
	    return true;
	  } else {
	    imageCache[src] = true;
	    return false;
	  }
	};
	
	var io = void 0;
	var listeners = [];
	
	function getIO() {
	  if (typeof io === "undefined" && typeof window !== "undefined" && window.IntersectionObserver) {
	    io = new window.IntersectionObserver(function (entries) {
	      entries.forEach(function (entry) {
	        listeners.forEach(function (l) {
	          if (l[0] === entry.target) {
	            // Edge doesn't currently support isIntersecting, so also test for an intersectionRatio > 0
	            if (entry.isIntersecting || entry.intersectionRatio > 0) {
	              io.unobserve(l[0]);
	              l[1]();
	            }
	          }
	        });
	      });
	    }, { rootMargin: "200px" });
	  }
	
	  return io;
	}
	
	var listenToIntersections = function listenToIntersections(el, cb) {
	  getIO().observe(el);
	  listeners.push([el, cb]);
	};
	
	var isWebpSupportedCache = null;
	var isWebpSupported = function isWebpSupported() {
	  if (isWebpSupportedCache !== null) {
	    return isWebpSupportedCache;
	  }
	
	  var elem = typeof window !== "undefined" ? window.document.createElement("canvas") : {};
	  if (elem.getContext && elem.getContext("2d")) {
	    isWebpSupportedCache = elem.toDataURL("image/webp").indexOf("data:image/webp") === 0;
	  } else {
	    isWebpSupportedCache = false;
	  }
	
	  return isWebpSupportedCache;
	};
	
	var noscriptImg = function noscriptImg(props) {
	  // Check if prop exists before adding each attribute to the string output below to prevent
	  // HTML validation issues caused by empty values like width="" and height=""
	  var src = props.src ? "src=\"" + props.src + "\" " : "src=\"\""; // required attribute
	  var srcSet = props.srcSet ? "srcset=\"" + props.srcSet + "\" " : "";
	  var sizes = props.sizes ? "sizes=\"" + props.sizes + "\" " : "";
	  var title = props.title ? "title=\"" + props.title + "\" " : "";
	  var alt = props.alt ? "alt=\"" + props.alt + "\" " : "alt=\"\""; // required attribute
	  var width = props.width ? "width=\"" + props.width + "\" " : "";
	  var height = props.height ? "height=\"" + props.height + "\" " : "";
	  var opacity = props.opacity ? props.opacity : "1";
	  var transitionDelay = props.transitionDelay ? props.transitionDelay : "0.5s";
	
	  return "<img " + width + height + src + srcSet + alt + title + sizes + "style=\"position:absolute;top:0;left:0;transition:opacity 0.5s;transition-delay:" + transitionDelay + ";opacity:" + opacity + ";width:100%;height:100%;object-fit:cover;object-position:center\"/>";
	};
	
	var Img = function Img(props) {
	  var style = props.style,
	      onLoad = props.onLoad,
	      otherProps = (0, _objectWithoutProperties3.default)(props, ["style", "onLoad"]);
	
	  return _react2.default.createElement("img", (0, _extends3.default)({}, otherProps, {
	    onLoad: onLoad,
	    style: (0, _extends3.default)({
	      position: "absolute",
	      top: 0,
	      left: 0,
	      transition: "opacity 0.5s",
	      width: "100%",
	      height: "100%",
	      objectFit: "cover",
	      objectPosition: "center"
	    }, style)
	  }));
	};
	
	Img.propTypes = {
	  style: _propTypes2.default.object,
	  onLoad: _propTypes2.default.func
	};
	
	var Image = function (_React$Component) {
	  (0, _inherits3.default)(Image, _React$Component);
	
	  function Image(props) {
	    (0, _classCallCheck3.default)(this, Image);
	
	    // If this browser doesn't support the IntersectionObserver API
	    // we default to start downloading the image right away.
	    var _this = (0, _possibleConstructorReturn3.default)(this, _React$Component.call(this, props));
	
	    var isVisible = true;
	    var imgLoaded = true;
	    var IOSupported = false;
	
	    // If this image has already been loaded before then we can assume it's
	    // already in the browser cache so it's cheap to just show directly.
	    var seenBefore = inImageCache(props);
	
	    if (!seenBefore && typeof window !== "undefined" && window.IntersectionObserver) {
	      isVisible = false;
	      imgLoaded = false;
	      IOSupported = true;
	    }
	
	    // Always don't render image while server rendering
	    if (typeof window === "undefined") {
	      isVisible = false;
	      imgLoaded = false;
	    }
	
	    _this.state = {
	      isVisible: isVisible,
	      imgLoaded: imgLoaded,
	      IOSupported: IOSupported
	    };
	
	    _this.handleRef = _this.handleRef.bind(_this);
	    return _this;
	  }
	
	  Image.prototype.handleRef = function handleRef(ref) {
	    var _this2 = this;
	
	    if (this.state.IOSupported && ref) {
	      listenToIntersections(ref, function () {
	        _this2.setState({ isVisible: true, imgLoaded: false });
	      });
	    }
	  };
	
	  Image.prototype.render = function render() {
	    var _this3 = this;
	
	    var _convertProps = convertProps(this.props),
	        title = _convertProps.title,
	        alt = _convertProps.alt,
	        className = _convertProps.className,
	        outerWrapperClassName = _convertProps.outerWrapperClassName,
	        _convertProps$style = _convertProps.style,
	        style = _convertProps$style === undefined ? {} : _convertProps$style,
	        _convertProps$imgStyl = _convertProps.imgStyle,
	        imgStyle = _convertProps$imgStyl === undefined ? {} : _convertProps$imgStyl,
	        sizes = _convertProps.sizes,
	        resolutions = _convertProps.resolutions,
	        backgroundColor = _convertProps.backgroundColor,
	        Tag = _convertProps.Tag;
	
	    var bgColor = void 0;
	    if (typeof backgroundColor === "boolean") {
	      bgColor = "lightgray";
	    } else {
	      bgColor = backgroundColor;
	    }
	
	    var imagePlaceholderStyle = (0, _extends3.default)({
	      opacity: this.state.imgLoaded ? 0 : 1,
	      transitionDelay: "0.25s"
	    }, imgStyle);
	
	    var imageStyle = (0, _extends3.default)({
	      opacity: this.state.imgLoaded || this.props.fadeIn === false ? 1 : 0
	    }, imgStyle);
	
	    if (sizes) {
	      var image = sizes;
	
	      // Use webp by default if browser supports it
	      if (image.srcWebp && image.srcSetWebp && isWebpSupported()) {
	        image.src = image.srcWebp;
	        image.srcSet = image.srcSetWebp;
	      }
	
	      // The outer div is necessary to reset the z-index to 0.
	      return _react2.default.createElement(
	        Tag,
	        {
	          className: (outerWrapperClassName ? outerWrapperClassName : "") + " gatsby-image-outer-wrapper",
	          style: {
	            // Let users set component to be absolutely positioned.
	            position: style.position === "absolute" ? "initial" : "relative"
	          }
	        },
	        _react2.default.createElement(
	          Tag,
	          {
	            className: (className ? className : "") + " gatsby-image-wrapper",
	            style: (0, _extends3.default)({
	              position: "relative",
	              overflow: "hidden"
	            }, style),
	            ref: this.handleRef
	          },
	          _react2.default.createElement(Tag, {
	            style: {
	              width: "100%",
	              paddingBottom: 100 / image.aspectRatio + "%"
	            }
	          }),
	          image.base64 && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            src: image.base64,
	            style: imagePlaceholderStyle
	          }),
	          image.tracedSVG && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            src: image.tracedSVG,
	            style: imagePlaceholderStyle
	          }),
	          bgColor && _react2.default.createElement(Tag, {
	            title: title,
	            style: {
	              backgroundColor: bgColor,
	              position: "absolute",
	              top: 0,
	              bottom: 0,
	              opacity: !this.state.imgLoaded ? 1 : 0,
	              transitionDelay: "0.35s",
	              right: 0,
	              left: 0
	            }
	          }),
	          this.state.isVisible && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            srcSet: image.srcSet,
	            src: image.src,
	            sizes: image.sizes,
	            style: imageStyle,
	            onLoad: function onLoad() {
	              _this3.state.IOSupported && _this3.setState({ imgLoaded: true });
	              _this3.props.onLoad && _this3.props.onLoad();
	            }
	          }),
	          _react2.default.createElement("noscript", {
	            dangerouslySetInnerHTML: {
	              __html: noscriptImg((0, _extends3.default)({ alt: alt, title: title }, image))
	            }
	          })
	        )
	      );
	    }
	
	    if (resolutions) {
	      var _image = resolutions;
	      var divStyle = (0, _extends3.default)({
	        position: "relative",
	        overflow: "hidden",
	        display: "inline-block",
	        width: _image.width,
	        height: _image.height
	      }, style);
	
	      if (style.display === "inherit") {
	        delete divStyle.display;
	      }
	
	      // Use webp by default if browser supports it
	      if (_image.srcWebp && _image.srcSetWebp && isWebpSupported()) {
	        _image.src = _image.srcWebp;
	        _image.srcSet = _image.srcSetWebp;
	      }
	
	      // The outer div is necessary to reset the z-index to 0.
	      return _react2.default.createElement(
	        Tag,
	        {
	          className: (outerWrapperClassName ? outerWrapperClassName : "") + " gatsby-image-outer-wrapper",
	          style: {
	            // Let users set component to be absolutely positioned.
	            position: style.position === "absolute" ? "initial" : "relative"
	          }
	        },
	        _react2.default.createElement(
	          Tag,
	          {
	            className: (className ? className : "") + " gatsby-image-wrapper",
	            style: divStyle,
	            ref: this.handleRef
	          },
	          _image.base64 && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            src: _image.base64,
	            style: imagePlaceholderStyle
	          }),
	          _image.tracedSVG && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            src: _image.tracedSVG,
	            style: imagePlaceholderStyle
	          }),
	          bgColor && _react2.default.createElement(Tag, {
	            title: title,
	            style: {
	              backgroundColor: bgColor,
	              width: _image.width,
	              opacity: !this.state.imgLoaded ? 1 : 0,
	              transitionDelay: "0.25s",
	              height: _image.height
	            }
	          }),
	          this.state.isVisible && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            width: _image.width,
	            height: _image.height,
	            srcSet: _image.srcSet,
	            src: _image.src,
	            style: imageStyle,
	            onLoad: function onLoad() {
	              _this3.setState({ imgLoaded: true });
	              _this3.props.onLoad && _this3.props.onLoad();
	            }
	          }),
	          _react2.default.createElement("noscript", {
	            dangerouslySetInnerHTML: {
	              __html: noscriptImg((0, _extends3.default)({
	                alt: alt,
	                title: title,
	                width: _image.width,
	                height: _image.height
	              }, _image))
	            }
	          })
	        )
	      );
	    }
	
	    return null;
	  };
	
	  return Image;
	}(_react2.default.Component);
	
	Image.defaultProps = {
	  fadeIn: true,
	  alt: "",
	  Tag: "div"
	};
	
	Image.propTypes = {
	  responsiveResolution: _propTypes2.default.object,
	  responsiveSizes: _propTypes2.default.object,
	  resolutions: _propTypes2.default.object,
	  sizes: _propTypes2.default.object,
	  fadeIn: _propTypes2.default.bool,
	  title: _propTypes2.default.string,
	  alt: _propTypes2.default.string,
	  className: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]), // Support Glamor's css prop.
	  outerWrapperClassName: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
	  style: _propTypes2.default.object,
	  imgStyle: _propTypes2.default.object,
	  position: _propTypes2.default.string,
	  backgroundColor: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.bool]),
	  onLoad: _propTypes2.default.func,
	  Tag: _propTypes2.default.string
	};
	
	exports.default = Image;

/***/ }),

/***/ 479:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ 480:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ 481:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDIyLjEuMCwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkxheWVyXzIiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4IgoJIHZpZXdCb3g9IjAgMCA3MiA3MiIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgNzIgNzI7IiB4bWw6c3BhY2U9InByZXNlcnZlIj4KPHN0eWxlIHR5cGU9InRleHQvY3NzIj4KCS5zdDB7ZmlsbDpub25lO3N0cm9rZTojMDAwMDAwO3N0cm9rZS13aWR0aDoyO3N0cm9rZS1taXRlcmxpbWl0OjEwO30KCS5zdDF7ZmlsbDojRkZGRkZGO3N0cm9rZTojMDAwMDAwO3N0cm9rZS13aWR0aDoyO3N0cm9rZS1taXRlcmxpbWl0OjEwO30KPC9zdHlsZT4KPGNpcmNsZSBjbGFzcz0ic3QwIiBjeD0iMzYuMSIgY3k9IjQzLjYiIHI9IjE5LjgiLz4KPGc+Cgk8cGF0aCBjbGFzcz0ic3QwIiBkPSJNMzEuNywxNmMwLDAtNC40LDEuNi02LjYsNS4ycy0yLjMsNy42LTIuMyw3LjYiLz4KCTxwYXRoIGNsYXNzPSJzdDAiIGQ9Ik00MC42LDE2YzAsMCw0LjQsMS42LDYuNiw1LjJzMi4zLDcuNiwyLjMsNy42Ii8+CjwvZz4KPGNpcmNsZSBjbGFzcz0ic3QxIiBjeD0iMzUuOSIgY3k9IjExLjMiIHI9IjYuMiIvPgo8Zz4KCTxwYXRoIGNsYXNzPSJzdDAiIGQ9Ik02MS45LDU0YzAsMCwwLjktNC42LTEuMS04LjRjLTItMy44LTUuNC01LjktNS40LTUuOSIvPgoJPHBhdGggY2xhc3M9InN0MCIgZD0iTTU3LjQsNjEuNmMwLDAtMy43LDMtNy45LDNzLTcuNy0xLjktNy43LTEuOSIvPgo8L2c+CjxjaXJjbGUgY2xhc3M9InN0MSIgY3g9IjYzLjgiIGN5PSI2MC4xIiByPSI2LjIiLz4KPGc+Cgk8cGF0aCBjbGFzcz0ic3QwIiBkPSJNMTAuMSw1NGMwLDAtMC45LTQuNiwxLjEtOC40czUuNC01LjksNS40LTUuOSIvPgoJPHBhdGggY2xhc3M9InN0MCIgZD0iTTE0LjYsNjEuNmMwLDAsMy43LDMsNy45LDNzNy43LTEuOSw3LjctMS45Ii8+CjwvZz4KPGNpcmNsZSBjbGFzcz0ic3QxIiBjeD0iOC4yIiBjeT0iNjAuMSIgcj0iNi4yIi8+CjxwYXRoIGNsYXNzPSJzdDEiIGQ9Ik00NS4yLDQwYy0wLjQtMS44LTEuOS0zLjEtMy4yLTMuNGMtMS40LTAuMy0yLjktMC4yLTQuMSwwLjljLTEuMiwxLjEtMS44LDIuNi0xLjgsMi42cy0wLjYtMS41LTEuOC0yLjYKCWMtMS4yLTEuMS0yLjctMS4yLTQuMS0wLjlTMjcuNCwzOC4xLDI3LDQwYy0wLjQsMS44LDAuMiwzLjMsMSw0LjZjMC44LDEuMywyLDIuNywzLjUsNGMxLjQsMS40LDQuNiwzLjksNC42LDMuOXMzLjItMi41LDQuNi0zLjkKCWMxLjQtMS40LDIuNi0yLjcsMy41LTRDNDUsNDMuMyw0NS42LDQxLjgsNDUuMiw0MHoiLz4KPC9zdmc+Cg=="

/***/ }),

/***/ 482:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ 483:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDIyLjEuMCwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgeD0iMHB4IiB5PSIwcHgiCgkgdmlld0JveD0iMCAwIDg5LjcgNzIiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDg5LjcgNzI7IiB4bWw6c3BhY2U9InByZXNlcnZlIj4KPHN0eWxlIHR5cGU9InRleHQvY3NzIj4KCS5zdDB7ZmlsbDpub25lO3N0cm9rZTojMDAwMDAwO3N0cm9rZS13aWR0aDoyO3N0cm9rZS1taXRlcmxpbWl0OjEwO30KCS5zdDF7ZmlsbDojRkZGRkZGO3N0cm9rZTojMDAwMDAwO3N0cm9rZS13aWR0aDoyO3N0cm9rZS1taXRlcmxpbWl0OjEwO30KPC9zdHlsZT4KPGcgaWQ9IkxheWVyXzEiPgo8L2c+CjxnIGlkPSJMYXllcl8yIj4KCTxjaXJjbGUgY2xhc3M9InN0MCIgY3g9IjQwIiBjeT0iNTAiIHI9IjE3LjQiLz4KCTxwYXRoIGNsYXNzPSJzdDEiIGQ9Ik00Ny43LDQ3LjRjLTAuMy0xLjUtMS42LTIuNi0yLjctMi44Yy0xLjItMC4zLTIuNS0wLjEtMy41LDAuOGMtMSwwLjktMS41LDIuMi0xLjUsMi4ycy0wLjUtMS4zLTEuNS0yLjIKCQljLTEtMC45LTIuMy0xLTMuNS0wLjhzLTIuNCwxLjMtMi43LDIuOGMtMC4zLDEuNSwwLjIsMi44LDAuOSwzLjljMC43LDEuMSwxLjcsMi4zLDIuOSwzLjRDMzcuMyw1NS44LDQwLDU4LDQwLDU4czIuNy0yLjEsMy45LTMuMwoJCXMyLjItMi4zLDIuOS0zLjRDNDcuNSw1MC4yLDQ4LDQ4LjksNDcuNyw0Ny40eiIvPgo8L2c+CjxnIGlkPSJMYXllcl8zIj4KCTxwYXRoIGNsYXNzPSJzdDAiIGQ9Ik00MC4xLDI0LjJjMCwwLDEwLjctMC42LDE5LjIsOC40YzcuNCw3LjksNi44LDE3LjUsNi44LDE3LjUiLz4KCTxwYXRoIGNsYXNzPSJzdDAiIGQ9Ik00MC4xLDE1LjZjMCwwLDE0LjMtMC44LDI1LjUsMTEuMmM5LjksMTAuNiw5LjEsMjMuMyw5LjEsMjMuMyIvPgoJPHBhdGggY2xhc3M9InN0MCIgZD0iTTQwLjEsNi44YzAsMCwxNy45LTAuOSwzMS45LDE0LjFjMTIuNCwxMy4yLDExLjQsMjkuMiwxMS40LDI5LjIiLz4KCTxsaW5lIGNsYXNzPSJzdDEiIHgxPSIyOC4yIiB5MT0iOC4yIiB4Mj0iMjguMiIgeTI9IjE2LjMiLz4KCTxsaW5lIGNsYXNzPSJzdDEiIHgxPSIzMi4yIiB5MT0iMTIuMiIgeDI9IjI0LjEiIHkyPSIxMi4yIi8+Cgk8bGluZSBjbGFzcz0ic3QxIiB4MT0iMTAiIHkxPSIxMy44IiB4Mj0iMTAiIHkyPSIxOSIvPgoJPGxpbmUgY2xhc3M9InN0MSIgeDE9IjEyLjYiIHkxPSIxNi40IiB4Mj0iNy40IiB5Mj0iMTYuNCIvPgoJPGxpbmUgY2xhc3M9InN0MSIgeDE9IjE5LjQiIHkxPSIyNi4yIiB4Mj0iMTkuNCIgeTI9IjMyLjYiLz4KCTxsaW5lIGNsYXNzPSJzdDEiIHgxPSIyMi42IiB5MT0iMjkuNCIgeDI9IjE2LjIiIHkyPSIyOS40Ii8+CjwvZz4KPC9zdmc+Cg=="

/***/ }),

/***/ 47:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.ButtonGone = exports.Button = undefined;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n    background-color: transparent;\n    border-color: ', ';\n    border-radius: 4px;\n    border-width: 3px;\n    border-style: ', ';\n    cursor: pointer;\n    display: inline-block;\n    font-size: 0.9em;\n    color: ', ';\n    font-weight: ', ';\n    font-family: ', ';\n    height: 2.75em;\n    letter-spacing: 0.125em;\n    line-height: 2.75em;\n    padding: 0 2em;\n    text-align: center;\n    text-decoration: none;\n    text-indent: 0.125em;\n    text-transform: uppercase;\n    white-space: nowrap;\n    &:hover {\n        color: ', ';\n        border-color: ', ';\n    }\n'], ['\n    background-color: transparent;\n    border-color: ', ';\n    border-radius: 4px;\n    border-width: 3px;\n    border-style: ', ';\n    cursor: pointer;\n    display: inline-block;\n    font-size: 0.9em;\n    color: ', ';\n    font-weight: ', ';\n    font-family: ', ';\n    height: 2.75em;\n    letter-spacing: 0.125em;\n    line-height: 2.75em;\n    padding: 0 2em;\n    text-align: center;\n    text-decoration: none;\n    text-indent: 0.125em;\n    text-transform: uppercase;\n    white-space: nowrap;\n    &:hover {\n        color: ', ';\n        border-color: ', ';\n    }\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n@media all and (max-width: 750px) {\n    display: none;\n}\n'], ['\n@media all and (max-width: 750px) {\n    display: none;\n}\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(10);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _styledComponents = __webpack_require__(8);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Button = _styledComponents2.default.button(_templateObject, function (props) {
	    return props.inverse ? props.theme.font_light : props.theme.font_dark;
	}, function (props) {
	    return props.unstyled ? 'none' : 'solid';
	}, function (props) {
	    return props.inverse ? props.theme.font_light : props.theme.font_dark;
	}, function (props) {
	    return props.theme.font_weight_bold;
	}, function (props) {
	    return props.font == 'body' ? props.theme.font_body : props.theme.font_header;
	}, function (props) {
	    return props.hover ? props.hover : props.theme.accent;
	}, function (props) {
	    return props.hover ? props.hover : props.theme.accent;
	});
	var ButtonGone = Button.extend(_templateObject2);
	exports.Button = Button;
	exports.ButtonGone = ButtonGone;

/***/ }),

/***/ 49:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.Hero = undefined;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n    z-index: 0;\n    padding: 12em 0 6em 0;\n    font-family: ', ';    \n    background-color: ', ';\n    color: ', ';\n    background-attachment: fixed;\n    background-image: \n        url(', ');\n    background-position: top left;\n    background-size: cover;\n    overflow: hidden;\n    position: relative;\n    text-align: ', ';\n    .background {\n        position: absolute;\n        top: 0;\n        left: 0;\n        height: 100%;\n        width: 100%;\n        display: block;\n        object-fit: cover;\n\n    }\n    \n    h1 {\n        font-size: 3em;\n        line-height: 1em;\n    }\n    p {\n        font-size: 1.15em;\n        margin: (', ' * 0.5) 0 0 0;\n    }\n    .inner {\n        opacity: 1;\n        position: relative;\n\n        .actions {\n            opacity: 1;\n        }\n    }\n    .actions {\n        margin: calc(', ' * 1.25) 0 0 0;\n    }\n    /* Media queries */\n    @media (max-width: 1680px){\n        padding: 14em 0 calc(', '*2.5) 0;        \n    }\n    @media (max-width: 1280px){\n        padding: 10em 0 calc(', '*2.4) 0;                \n        br {\n            display: inline;\n        }\n    }\n    @media (max-width: 980px){\n        font-size: 0.75em;\n        padding: 8em 0 calc(', '*2.25) 0;                \n    }\n    @media (max-width: 736px){    \n        padding: 6em 0 calc(', '*2) 0;\n        h1 {\n            font-size: 2.5em;\n        }\n    }\n    @media (max-width: 480px) {\n            padding: 6em 0 calc(', '*2) 0;    \n    }\n    @media (max-width: 360px) {\n        padding: 4em 0 calc(', '*2) 0;\n    }\n'], ['\n    z-index: 0;\n    padding: 12em 0 6em 0;\n    font-family: ', ';    \n    background-color: ', ';\n    color: ', ';\n    background-attachment: fixed;\n    background-image: \n        url(', ');\n    background-position: top left;\n    background-size: cover;\n    overflow: hidden;\n    position: relative;\n    text-align: ', ';\n    .background {\n        position: absolute;\n        top: 0;\n        left: 0;\n        height: 100%;\n        width: 100%;\n        display: block;\n        object-fit: cover;\n\n    }\n    \n    h1 {\n        font-size: 3em;\n        line-height: 1em;\n    }\n    p {\n        font-size: 1.15em;\n        margin: (', ' * 0.5) 0 0 0;\n    }\n    .inner {\n        opacity: 1;\n        position: relative;\n\n        .actions {\n            opacity: 1;\n        }\n    }\n    .actions {\n        margin: calc(', ' * 1.25) 0 0 0;\n    }\n    /* Media queries */\n    @media (max-width: 1680px){\n        padding: 14em 0 calc(', '*2.5) 0;        \n    }\n    @media (max-width: 1280px){\n        padding: 10em 0 calc(', '*2.4) 0;                \n        br {\n            display: inline;\n        }\n    }\n    @media (max-width: 980px){\n        font-size: 0.75em;\n        padding: 8em 0 calc(', '*2.25) 0;                \n    }\n    @media (max-width: 736px){    \n        padding: 6em 0 calc(', '*2) 0;\n        h1 {\n            font-size: 2.5em;\n        }\n    }\n    @media (max-width: 480px) {\n            padding: 6em 0 calc(', '*2) 0;    \n    }\n    @media (max-width: 360px) {\n        padding: 4em 0 calc(', '*2) 0;\n    }\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(10);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _styledComponents = __webpack_require__(8);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Hero = _styledComponents2.default.header(_templateObject, function (props) {
	    return props.theme.font_header;
	}, function (props) {
	    return props.dark ? props.theme.bg_dark : props.theme.bg_light;
	}, function (props) {
	    return props.dark ? props.theme.font_light : props.theme.font_dark;
	}, function (props) {
	    return props.image;
	}, function (props) {
	    return props.centered ? 'center' : 'left';
	}, function (props) {
	    return props.theme.element_margin;
	}, function (props) {
	    return props.theme.element_margin;
	}, function (props) {
	    return props.theme.element_margin;
	}, function (props) {
	    return props.theme.element_margin;
	}, function (props) {
	    return props.theme.element_margin;
	}, function (props) {
	    return props.theme.element_margin;
	}, function (props) {
	    return props.theme.element_margin;
	}, function (props) {
	    return props.theme.element_margin;
	});
	
	exports.Hero = Hero;

/***/ }),

/***/ 218:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(10);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactHelmet = __webpack_require__(64);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _styledComponents = __webpack_require__(8);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _gatsbyImage = __webpack_require__(59);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _grid = __webpack_require__(27);
	
	var _segment = __webpack_require__(50);
	
	var _theme = __webpack_require__(51);
	
	var _header = __webpack_require__(28);
	
	var _icon = __webpack_require__(141);
	
	var _footer = __webpack_require__(48);
	
	var _wrapper = __webpack_require__(52);
	
	var _hero = __webpack_require__(49);
	
	var _button = __webpack_require__(47);
	
	var _navbar = __webpack_require__(67);
	
	var _Harvest_Crowdfund = __webpack_require__(479);
	
	var _Harvest_Crowdfund2 = _interopRequireDefault(_Harvest_Crowdfund);
	
	var _Harvest_Exchange = __webpack_require__(480);
	
	var _Harvest_Exchange2 = _interopRequireDefault(_Harvest_Exchange);
	
	var _Harvest_InteractFans = __webpack_require__(481);
	
	var _Harvest_InteractFans2 = _interopRequireDefault(_Harvest_InteractFans);
	
	var _Harvest_Network = __webpack_require__(482);
	
	var _Harvest_Network2 = _interopRequireDefault(_Harvest_Network);
	
	var _Harvest_RewardArtists = __webpack_require__(483);
	
	var _Harvest_RewardArtists2 = _interopRequireDefault(_Harvest_RewardArtists);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TreblekeyPage = function TreblekeyPage(props) {
	    return _react2.default.createElement(
	        _styledComponents.ThemeProvider,
	        { theme: _theme.HarvestTheme },
	        _react2.default.createElement(
	            _wrapper.Wrapper,
	            null,
	            _react2.default.createElement(
	                _segment.Segment,
	                { style: { height: 0, padding: 0, margin: 0, zIndex: 999 } },
	                _react2.default.createElement(
	                    _navbar.Navbar,
	                    null,
	                    _react2.default.createElement(
	                        'h3',
	                        null,
	                        _react2.default.createElement(
	                            'a',
	                            { href: '#top' },
	                            'Harvest'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'a',
	                        { href: '#rewards' },
	                        'Rewards'
	                    ),
	                    _react2.default.createElement(
	                        'a',
	                        { href: '#users' },
	                        'Users'
	                    ),
	                    _react2.default.createElement(
	                        'a',
	                        { href: '#system' },
	                        'System'
	                    )
	                )
	            ),
	            _react2.default.createElement('div', { id: 'top', style: { height: '3em' } }),
	            _react2.default.createElement(_reactHelmet2.default, { title: 'Harvest' }),
	            _react2.default.createElement(
	                _hero.Hero,
	                { centered: true, style: { backgroundColor: '#FADE21', height: '30em' } },
	                _react2.default.createElement(
	                    _header.Header,
	                    { id: 'h1', style: {
	                            overflow: 'hidden',
	                            position: 'absolute',
	                            top: '55%',
	                            left: '50%',
	                            transform: 'translate(-50%, -50%)',
	                            margin: 'auto'
	                        } },
	                    _react2.default.createElement(
	                        'h1',
	                        { style: { position: 'relative', lineHeight: '1.5em', fontSize: '5rem' } },
	                        'Reward',
	                        _react2.default.createElement('br', null),
	                        'Creation'
	                    )
	                ),
	                _react2.default.createElement(
	                    _header.Header,
	                    { inverse: true, style: {
	                            zIndex: 1,
	                            position: 'absolute',
	                            top: '50%',
	                            left: '50%',
	                            transform: 'translate(-50%, -50%)',
	                            margin: 'auto'
	                        } },
	                    _react2.default.createElement(
	                        'h3',
	                        { style: { position: 'relative' } },
	                        'EMPOWERING ARTISTS IN THE DIGITAL AGE'
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                _segment.Segment,
	                { dark: true },
	                _react2.default.createElement('div', { id: 'vision', style: { position: 'relative', top: '-100px' } }),
	                _react2.default.createElement(_gatsbyImage2.default, {
	                    style: { position: 'absolute', opacity: '0.3' },
	                    title: 'Accent image',
	                    alt: 'guitars',
	                    className: 'background',
	                    sizes: props.data.pic01.sizes
	                }),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'inner', style: { zIndex: 1 } },
	                    _react2.default.createElement(
	                        _grid.Grid,
	                        null,
	                        _react2.default.createElement(
	                            _header.AbsoluteHeader,
	                            { accent: true },
	                            _react2.default.createElement(
	                                _grid.Grid,
	                                null,
	                                _react2.default.createElement(
	                                    _grid.Column,
	                                    { span: '12' },
	                                    _react2.default.createElement(
	                                        'h1',
	                                        { style: { overflow: 'hidden', position: 'relative', lineHeight: '1.5em', fontSize: '8em' } },
	                                        'Vision'
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(_grid.Column, { style: { position: 'relative', height: '8rem' }, span: '12' }),
	                        _react2.default.createElement(_grid.Column, { span: '4' }),
	                        _react2.default.createElement(
	                            _grid.Column,
	                            { span: '7' },
	                            _react2.default.createElement(
	                                _header.Header,
	                                { inverse: true },
	                                _react2.default.createElement(
	                                    'h4',
	                                    null,
	                                    'OUR VISION',
	                                    _react2.default.createElement(
	                                        'div',
	                                        { style: { fontSize: '2em', transform: 'scaleY(0.5)' } },
	                                        '-'
	                                    )
	                                )
	                            ),
	                            'We want artists to all be rewarded equally, based only on how much their fans love their music, not on whether its an ad-based stream, or what their deal split is with distributors & labels.',
	                            _react2.default.createElement('br', null),
	                            _react2.default.createElement('br', null),
	                            'Pure, direct, whole rewards, from your fans!'
	                        ),
	                        _react2.default.createElement(_grid.Column, { style: { position: 'relative', height: '6em' }, span: '12' })
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                _segment.Segment,
	                { centered: true },
	                _react2.default.createElement('div', { id: 'rewards', style: { position: 'relative', top: '-100px' } }),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'inner' },
	                    _react2.default.createElement(
	                        _grid.Grid,
	                        null,
	                        _react2.default.createElement(
	                            _grid.Column,
	                            { span: '12' },
	                            _react2.default.createElement(
	                                _header.Header,
	                                null,
	                                _react2.default.createElement(
	                                    'h1',
	                                    { style: { fontSize: '6rem' } },
	                                    'Rewards'
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(_grid.Column, { span: '1' }),
	                        _react2.default.createElement(
	                            _grid.Column,
	                            { span: '10' },
	                            _react2.default.createElement(
	                                'h4',
	                                { style: { color: 'black' } },
	                                'MOST REWARDS PROGRAMS ARE TIGHTLY CONTROLLED...'
	                            ),
	                            _react2.default.createElement(
	                                'p',
	                                { style: { color: 'black' } },
	                                'Someone tells you when you can use your rewards, how you can use them, and charge ',
	                                _react2.default.createElement('br', null),
	                                'you when you want to want to give them away.'
	                            )
	                        ),
	                        _react2.default.createElement(_grid.Column, { span: '1' }),
	                        _react2.default.createElement(_grid.Column, { span: '1' }),
	                        _react2.default.createElement(
	                            _grid.Column,
	                            { span: '10' },
	                            _react2.default.createElement(
	                                'h4',
	                                { style: { color: 'black' } },
	                                'HARVEST WANTS TO CHANGE ALL OF THAT'
	                            )
	                        ),
	                        _react2.default.createElement(_grid.Column, { span: '1' }),
	                        _react2.default.createElement(_grid.Column, { span: '2' }),
	                        _react2.default.createElement(
	                            _grid.Column,
	                            { span: '4' },
	                            _react2.default.createElement('img', { src: _Harvest_RewardArtists2.default, style: { display: 'block', width: '7.5rem', margin: 'auto', padding: '2px' } }),
	                            _react2.default.createElement(
	                                'p',
	                                { style: { color: 'black' } },
	                                _react2.default.createElement(
	                                    'b',
	                                    null,
	                                    'Reward artists based on ',
	                                    _react2.default.createElement('br', null),
	                                    ' how much their fans ',
	                                    _react2.default.createElement('br', null),
	                                    'listened, not how!'
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            _grid.Column,
	                            { span: '4' },
	                            _react2.default.createElement('img', { src: _Harvest_Crowdfund2.default, style: { display: 'block', width: '6.25rem', margin: 'auto', padding: '5px' } }),
	                            _react2.default.createElement(
	                                'p',
	                                { style: { color: 'black' } },
	                                _react2.default.createElement(
	                                    'b',
	                                    null,
	                                    'Trade, donate or crowd- ',
	                                    _react2.default.createElement('br', null),
	                                    'fund with your points  ',
	                                    _react2.default.createElement('br', null),
	                                    ' freely!'
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(_grid.Column, { span: '2' }),
	                        _react2.default.createElement(
	                            _grid.Column,
	                            { span: '4' },
	                            _react2.default.createElement('img', { src: _Harvest_Network2.default, style: { display: 'block', width: '6.25rem', margin: 'auto', padding: '2px' } }),
	                            _react2.default.createElement(
	                                'p',
	                                { style: { color: 'black' } },
	                                _react2.default.createElement(
	                                    'b',
	                                    null,
	                                    'Connect through a great ',
	                                    _react2.default.createElement('br', null),
	                                    ' network of apps!'
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            _grid.Column,
	                            { span: '4' },
	                            _react2.default.createElement('img', { src: _Harvest_InteractFans2.default, style: { display: 'block', width: '6.25rem', margin: 'auto', padding: '2px' } }),
	                            _react2.default.createElement(
	                                'p',
	                                { style: { color: 'black' } },
	                                _react2.default.createElement(
	                                    'b',
	                                    null,
	                                    'Interact and reward your ',
	                                    _react2.default.createElement('br', null),
	                                    ' biggest fans!'
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            _grid.Column,
	                            { span: '4' },
	                            _react2.default.createElement('img', { src: _Harvest_Exchange2.default, style: { display: 'block', width: '7.5rem', margin: 'auto', padding: '2px' } }),
	                            _react2.default.createElement(
	                                'p',
	                                { style: { color: 'black', padding: '5px 0px 0px 0px' } },
	                                _react2.default.createElement(
	                                    'b',
	                                    null,
	                                    'Exchange your points for ',
	                                    _react2.default.createElement('br', null),
	                                    ' real services!*'
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(_grid.Column, { span: '2' }),
	                        _react2.default.createElement(
	                            _grid.Column,
	                            { span: '8' },
	                            _react2.default.createElement('br', null),
	                            _react2.default.createElement(
	                                'p',
	                                { style: { color: 'black' } },
	                                '*studio time, marketing, PPC advertising campaigns and more! '
	                            ),
	                            _react2.default.createElement('br', null)
	                        ),
	                        _react2.default.createElement(_grid.Column, { span: '2' })
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                _segment.Segment,
	                { dark: true },
	                _react2.default.createElement('div', { id: 'users', style: { position: 'relative', top: '-100px' } }),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'inner' },
	                    _react2.default.createElement(
	                        _grid.Grid,
	                        null,
	                        _react2.default.createElement(
	                            _header.AbsoluteHeader,
	                            { accent: true },
	                            _react2.default.createElement(
	                                _grid.Grid,
	                                null,
	                                _react2.default.createElement(
	                                    _grid.Column,
	                                    { span: '12' },
	                                    _react2.default.createElement(
	                                        'h1',
	                                        { style: { overflow: 'hidden', position: 'relative', lineHeight: '1.5em', fontSize: '8em' } },
	                                        'Users'
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(_grid.Column, { style: { position: 'relative', height: '10rem' }, span: '12' }),
	                        _react2.default.createElement(
	                            _grid.Column,
	                            { span: '4', style: { textAlign: 'center' } },
	                            _react2.default.createElement(
	                                _header.Header,
	                                { inverse: true },
	                                _react2.default.createElement(
	                                    'h5',
	                                    null,
	                                    'ARTISTS',
	                                    _react2.default.createElement(
	                                        'div',
	                                        { style: { fontSize: '2em', transform: 'scaleY(0.5)' } },
	                                        '-'
	                                    )
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'p',
	                                null,
	                                'can use their points any way they want. Hold them, use them to reward fans, collect them from fans to fund the next recording, or toss them away. It was your music, so it\'s your reward!'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            _grid.Column,
	                            { span: '4', style: { textAlign: 'center' } },
	                            _react2.default.createElement(
	                                _header.Header,
	                                { inverse: true },
	                                _react2.default.createElement(
	                                    'h5',
	                                    null,
	                                    'FANS',
	                                    _react2.default.createElement(
	                                        'div',
	                                        { style: { fontSize: '2em', transform: 'scaleY(0.5)' } },
	                                        '-'
	                                    )
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'p',
	                                null,
	                                'can support their favourite artist by donating points safely commiting to a crowdfunding campaign or simply just buying them'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            _grid.Column,
	                            { span: '4', style: { textAlign: 'center' } },
	                            _react2.default.createElement(
	                                _header.Header,
	                                { inverse: true },
	                                _react2.default.createElement(
	                                    'h5',
	                                    null,
	                                    'VENDORS & LABELS',
	                                    _react2.default.createElement(
	                                        'div',
	                                        { style: { fontSize: '2em', transform: 'scaleY(0.5)' } },
	                                        '-'
	                                    )
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'p',
	                                null,
	                                'and others can accept points for services, buy and sell them on a exchange trade them for services themselves. Make a ',
	                                _react2.default.createElement('br', null),
	                                'difference by supporting a free, open, transparent rewards program for artists!'
	                            )
	                        ),
	                        _react2.default.createElement(_grid.Column, { style: { position: 'relative', height: '6em' }, span: '12' })
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                _segment.Segment,
	                { centered: true },
	                _react2.default.createElement('div', { id: 'system', style: { position: 'relative', top: '-100px' } }),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'inner' },
	                    _react2.default.createElement(
	                        _grid.Grid,
	                        null,
	                        _react2.default.createElement(
	                            _grid.Column,
	                            { span: '12' },
	                            _react2.default.createElement(
	                                _header.Header,
	                                null,
	                                _react2.default.createElement(
	                                    'h1',
	                                    { style: { fontSize: '5rem' } },
	                                    'GET INVOLVED'
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(_grid.Column, { span: '2' }),
	                        _react2.default.createElement(
	                            _grid.Column,
	                            { span: '8' },
	                            _react2.default.createElement(
	                                _header.Header,
	                                { inverse: true },
	                                _react2.default.createElement(
	                                    'a',
	                                    { href: 'mailto:canada@membran.net', style: { borderBottom: 'none' } },
	                                    _react2.default.createElement(
	                                        _button.Button,
	                                        { hover: 'white', unstyled: 'true', font: 'body', inverse: true },
	                                        _react2.default.createElement(
	                                            'h3',
	                                            null,
	                                            'CONTACT US!'
	                                        )
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'h5',
	                                    null,
	                                    _react2.default.createElement(
	                                        'div',
	                                        { style: { fontSize: '2em', transform: 'scaleY(0.5)' } },
	                                        '-'
	                                    )
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'p',
	                                { style: { color: 'black' } },
	                                _react2.default.createElement(
	                                    'b',
	                                    null,
	                                    'Express your interest learn more, and help us build a new ',
	                                    _react2.default.createElement('br', null),
	                                    'music ecosystem based on equality. '
	                                )
	                            )
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                _footer.Footer,
	                { dark: true },
	                _react2.default.createElement('div', null),
	                _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(
	                        _header.Header,
	                        null,
	                        _react2.default.createElement(
	                            'h3',
	                            { style: { color: 'black', fontSize: '20', textAlign: 'center', fontWeight: '700' } },
	                            'EXPLORE'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'ul',
	                        { style: { listStyle: 'none', textAlign: 'center' } },
	                        _react2.default.createElement(
	                            'h1',
	                            null,
	                            '-'
	                        ),
	                        _react2.default.createElement(
	                            'li',
	                            { style: { fontSize: '16' } },
	                            _react2.default.createElement(
	                                'a',
	                                { href: 'http://www.membran.net' },
	                                'MEMBRAN.NET'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'li',
	                            { style: { fontSize: '16' } },
	                            _react2.default.createElement(
	                                'a',
	                                { href: '/' },
	                                'MEMBRANLABS.COM'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'li',
	                            { style: { fontSize: '16' } },
	                            _react2.default.createElement(
	                                'a',
	                                { href: '/treblekey' },
	                                'TREBLEKEY'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'li',
	                            { style: { fontSize: '16' } },
	                            _react2.default.createElement(
	                                _header.Accent,
	                                null,
	                                'HARVEST'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'li',
	                            { style: { fontSize: '16' } },
	                            _react2.default.createElement(
	                                'a',
	                                { href: '/hyperstate' },
	                                'HYPERSTATE'
	                            )
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(
	                        _header.Header,
	                        null,
	                        _react2.default.createElement(
	                            'h3',
	                            { style: { color: 'black', fontSize: '20', textAlign: 'center', fontWeight: '700' } },
	                            'CONTACT US'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'ul',
	                        { style: { listStyle: 'none', textAlign: 'center' } },
	                        _react2.default.createElement(
	                            'h1',
	                            null,
	                            '-'
	                        ),
	                        _react2.default.createElement(
	                            'li',
	                            { style: { fontSize: '16' } },
	                            _react2.default.createElement(
	                                'a',
	                                { href: 'mailto:canada@membran.net' },
	                                'EMAIL'
	                            )
	                        )
	                    )
	                )
	            )
	        )
	    );
	};
	
	// svg files
	exports.default = TreblekeyPage;
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-harvest-js-b6bfb6ea67cf134ac38d.js